import script from "./switchGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./switchGroup.vue?vue&type=script&setup=true&lang=ts"

import "./switchGroup.vue?vue&type=style&index=0&id=f213a080&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f213a080"]])

export default __exports__